<template>
  <div>
    <ol class="breadcrumb float-xl-right">
      <li class="breadcrumb-item active">
        <a href="javascript:;">CONTROL DETALLES</a>
      </li>
    </ol>
    <h1 class="page-header">DETALLE DE <b>{{ $route.params.personal }}</b></h1>
    <h3>
      RANGO DE CERTIFICADOS ({{ $route.params.inicial }} -
      {{ $route.params.final }})
    </h3>
    <button 
  type="button" 
  class="btn btn-secondary" 
  @click="$router.back()"
>
  <i class="fa fa-arrow-left"></i> Atrás
</button>
    <div class="table-responsive card">
      <table v-if="nuevoArrayCertificados.length > 0" class="table table-hover">
        <thead>
          <tr class="text-center">
            <th>CERTIFICADOS</th>
            <th>PLACA VEHÍCULO</th>
            <th>ESTADO</th>
            <th>FECHA</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="text-center"
            v-for="rang in nuevoArrayCertificados"
            :key="rang.certificado"
          >
            <th class="h3">{{ rang.certificado }}</th>
            <th class="h3">{{ rang.placa_rodaje }}</th>
            <td class="bg bg-green">CODIGO USADO</td>
            <td class="h3">{{ rang.fecha_add }}</td>
          </tr>
       
        </tbody>
      </table>

      <table v-if="nuevoArrayCertificados.length > 0" class="table table-hover text-center">
        <thead>
        <tr>
          <th>Mes</th>
          <th>Cantidad</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in resumenMeses" :key="index">
          <td>{{ item.mes }}</td>
          <td>{{ item.cantidad }}</td>
        </tr>
      </tbody>
      </table>
      <div v-if="nuevoArrayCertificados.length == 0" class="alert alert-info">
        <span class="h3"
          >AÚN NO SE HAN USADOS LOS NÚMEROS DE LOS CERTIFICADOS</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import serviceControl from "../services/serviceControl";
export default {
  name: "PageControlDetalles",
  data() {
    return {
      certificados: [],
      nuevoArrayCertificados: [],
      rangoCalculado: [],

      inicial: "",
      final: "",
      tipo: "",
      dni: "",
    };
  },
  created() {
    this.inicial = this.$route.params.inicial;
    this.final = this.$route.params.final;
    this.dni = this.$route.params.dni;
    this.tipo = this.$route.params.tipo;
    this.getCertificadosRango();
    this.getRango();
  },
  methods: {
   
    getRango() {
      let inicial = this.inicial;
      for (inicial; inicial <= this.final; inicial++) {
        this.rangoCalculado.push(inicial);
      }
    },
    async getCertificadosRango() {
      try {
        const response = await serviceControl.searchRangeControl(
          this.dni,
          this.tipo,
          this.inicial,
          this.final
        );
        if (response.data.length > 0) {
          this.certificados = response.data[0];
          this.exito("Espere a que termine el proceso");
          this.nuevoArrayCertificados = this.certificados;
        } else {
          this.advertencia("No se encontró certificados");
        }
      } catch (error) {
        this.error(
          "No se han utilizado los números de los certificados asignados"
        );
      }
    },
    contarPorMes0(data) {
    // Nombres de meses en español
    const meses = [
      "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
      "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];

    // Objeto para almacenar los conteos
    const resultado = {};

    data.forEach(item => {
      if (!item.fecha_add) return; // Validación

      // Extraer el mes de la fecha
      const fecha = new Date(item.fecha_add);
      const mesIndex = fecha.getMonth(); // 0 = Enero, 11 = Diciembre
      const nombreMes = meses[mesIndex];

      // Contar
      if (!resultado[nombreMes]) {
        resultado[nombreMes] = 0;
      }
      resultado[nombreMes]++;
    });

    return resultado;
  },
  contarPorMes(data) {
    const meses = [
      "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
      "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];

    const conteo = {};

    data.forEach(item => {
      if (!item.fecha_add) return;

      const fecha = new Date(item.fecha_add);
      const mesIndex = fecha.getMonth();
      const nombreMes = meses[mesIndex];

      conteo[nombreMes] = (conteo[nombreMes] || 0) + 1;
    });

    // Convertir a array de objetos (ideal para la tabla)
    return Object.keys(conteo).map(mes => ({
      mes,
      cantidad: conteo[mes]
    }));
  }

  },
   computed: {
    resumenMeses() {
      return this.contarPorMes(this.nuevoArrayCertificados);
    }
  },
};
</script>